/*
 * Copyright 2022, TeamDev. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Redistribution and use in source and/or binary forms, with or without
 * modification, must retain the above copyright notice and the following
 * disclaimer.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FirebaseClientFactory = void 0;

var _rxjs = require("rxjs");

var _subscription_pb = require("../proto/spine/client/subscription_pb");

var _actorRequestFactory = require("./actor-request-factory");

var _clientFactory = require("./client-factory");

var _commandingClient = require("./commanding-client");

var _compositeClient = require("./composite-client");

var _httpClient = require("./http-client");

var _httpEndpoint = require("./http-endpoint");

var _firebaseDatabaseClient = require("./firebase-database-client");

var _firebaseSubscriptionService = require("./firebase-subscription-service");

var _objectToProto = _interopRequireDefault(require("./object-to-proto"));

var _queryingClient = require("./querying-client");

var _subscribingClient = require("./subscribing-client");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * An abstract base for subscription objects.
 *
 * @abstract
 */
var SpineSubscription = /*#__PURE__*/function (_Subscription) {
  _inherits(SpineSubscription, _Subscription);

  var _super = _createSuper(SpineSubscription);

  /**
   * @param {Function} unsubscribe the callbacks that allows to cancel the subscription
   * @param {SubscriptionObject} subscription the wrapped subscription object
   *
   * @protected
   */
  function SpineSubscription(unsubscribe, subscription) {
    var _this;

    _classCallCheck(this, SpineSubscription);

    _this = _super.call(this, unsubscribe);
    _this._subscription = subscription;
    return _this;
  }
  /**
   * An internal Spine subscription which includes the topic the updates are received for.
   *
   * @return {SubscriptionObject} a `spine.client.Subscription` instance
   */


  _createClass(SpineSubscription, [{
    key: "internal",
    value: function internal() {
      return this._subscription;
    }
    /**
     * @return {String} a string value of the `internal` subscription ID.
     */

  }, {
    key: "id",
    value: function id() {
      return this.internal().getId().getValue();
    }
  }]);

  return SpineSubscription;
}(_rxjs.Subscription);
/**
 * A subscription to entity changes on application backend.
 */


var EntitySubscription = /*#__PURE__*/function (_SpineSubscription) {
  _inherits(EntitySubscription, _SpineSubscription);

  var _super2 = _createSuper(EntitySubscription);

  /**
   * @param {Function} unsubscribe the callbacks that allows to cancel the subscription
   * @param {{itemAdded: Observable, itemChanged: Observable, itemRemoved: Observable}} observables
   *        the observables for entity changes
   * @param {SubscriptionObject} subscription the wrapped subscription object
   */
  function EntitySubscription(_ref) {
    var _this2;

    var unsubscribe = _ref.unsubscribedBy,
        observables = _ref.withObservables,
        subscription = _ref.forInternal;

    _classCallCheck(this, EntitySubscription);

    _this2 = _super2.call(this, unsubscribe, subscription);
    _this2._observables = observables;
    return _this2;
  }
  /**
   * @return {EntitySubscriptionObject} a plain object with observables and unsubscribe method
   */


  _createClass(EntitySubscription, [{
    key: "toObject",
    value: function toObject() {
      var _this3 = this;

      return Object.assign({}, this._observables, {
        unsubscribe: function unsubscribe() {
          return _this3.unsubscribe();
        }
      });
    }
  }]);

  return EntitySubscription;
}(SpineSubscription);
/**
 * A subscription to events that occur in the system.
 */


var EventSubscription = /*#__PURE__*/function (_SpineSubscription2) {
  _inherits(EventSubscription, _SpineSubscription2);

  var _super3 = _createSuper(EventSubscription);

  /**
   * @param {Function} unsubscribe the callbacks that allows to cancel the subscription
   * @param {Observable} eventEmitted the observable for the emitted events
   * @param {SubscriptionObject} subscription the wrapped subscription object
   */
  function EventSubscription(_ref2) {
    var _this4;

    var unsubscribe = _ref2.unsubscribedBy,
        observable = _ref2.withObservable,
        subscription = _ref2.forInternal;

    _classCallCheck(this, EventSubscription);

    _this4 = _super3.call(this, unsubscribe, subscription);
    _this4._observable = observable;
    return _this4;
  }
  /**
   * @return {EventSubscriptionObject} a plain object with observables and unsubscribe method
   */


  _createClass(EventSubscription, [{
    key: "toObject",
    value: function toObject() {
      var _this5 = this;

      return Object.assign({}, {
        eventEmitted: this._observable
      }, {
        unsubscribe: function unsubscribe() {
          return _this5.unsubscribe();
        }
      });
    }
  }]);

  return EventSubscription;
}(SpineSubscription);

var FirebaseQueryingClient = /*#__PURE__*/function (_QueryingClient) {
  _inherits(FirebaseQueryingClient, _QueryingClient);

  var _super4 = _createSuper(FirebaseQueryingClient);

  /**
   * A protected constructor for customization.
   *
   * Use `FirebaseClient#usingFirebase()` for instantiation
   *
   * @param {!HttpEndpoint} endpoint the server endpoint to execute queries and commands
   * @param {!FirebaseDatabaseClient} firebaseDatabase the client to read the query results from
   * @param {!ActorRequestFactory} actorRequestFactory a factory to instantiate the actor requests with
   *
   * @protected
   */
  function FirebaseQueryingClient(endpoint, firebaseDatabase, actorRequestFactory) {
    var _this6;

    _classCallCheck(this, FirebaseQueryingClient);

    _this6 = _super4.call(this, actorRequestFactory);
    _this6._endpoint = endpoint;
    _this6._firebase = firebaseDatabase;
    return _this6;
  }

  _createClass(FirebaseQueryingClient, [{
    key: "read",
    value: function read(query) {
      var _this7 = this;

      return new Promise(function (resolve, reject) {
        _this7._endpoint.query(query).then(function (_ref3) {
          var path = _ref3.path;
          return _this7._firebase.getValues(path, function (values) {
            var typeUrl = query.getTarget().getType();
            var messages = values.map(function (value) {
              return _objectToProto["default"].convert(value, typeUrl);
            });
            resolve(messages);
          });
        })["catch"](function (error) {
          return reject(error);
        });
      });
    }
  }]);

  return FirebaseQueryingClient;
}(_queryingClient.QueryingClient);

var EVENT_TYPE_URL = 'type.spine.io/spine.core.Event';
/**
 * A {@link SubscribingClient} which receives entity state updates and events from
 * a Firebase Realtime Database.
 */

var FirebaseSubscribingClient = /*#__PURE__*/function (_SubscribingClient) {
  _inherits(FirebaseSubscribingClient, _SubscribingClient);

  var _super5 = _createSuper(FirebaseSubscribingClient);

  /**
   * A protected constructor for customization.
   *
   * Use `FirebaseClient#usingFirebase()` for instantiation.
   *
   * @param {!HttpEndpoint} endpoint
   *  the server endpoint to execute queries and commands
   * @param {!FirebaseDatabaseClient} firebaseDatabase
   *  the client to read the query results from
   * @param {!ActorRequestFactory} actorRequestFactory
   *  a factory to instantiate the actor requests with
   * @param {!FirebaseSubscriptionService} subscriptionService
   *  a service handling the subscriptions
   *
   * @protected
   */
  function FirebaseSubscribingClient(endpoint, firebaseDatabase, actorRequestFactory, subscriptionService) {
    var _this8;

    _classCallCheck(this, FirebaseSubscribingClient);

    _this8 = _super5.call(this, actorRequestFactory);
    _this8._endpoint = endpoint;
    _this8._firebase = firebaseDatabase;
    _this8._subscriptionService = subscriptionService;
    return _this8;
  }
  /**
   * @inheritDoc
   */


  _createClass(FirebaseSubscribingClient, [{
    key: "subscribe",
    value: function subscribe(topic) {
      return this._doSubscribe(topic, this._entitySubscription);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "subscribeToEvents",
    value: function subscribeToEvents(topic) {
      return this._doSubscribe(topic, this._eventSubscription);
    }
    /**
     * @private
     */

  }, {
    key: "_doSubscribe",
    value: function _doSubscribe(topic, createSubscriptionFn) {
      var _this9 = this;

      return new Promise(function (resolve, reject) {
        _this9._endpoint.subscribeTo(topic).then(function (response) {
          var path = response.nodePath.value;
          var internalSubscription = FirebaseSubscribingClient.internalSubscription(path, topic);
          var subscription = createSubscriptionFn.call(_this9, path, internalSubscription);
          resolve(subscription.toObject());

          _this9._subscriptionService.add(subscription);
        })["catch"](reject);
      });
    }
    /**
     * @private
     */

  }, {
    key: "_entitySubscription",
    value: function _entitySubscription(path, subscription) {
      var itemAdded = new _rxjs.Subject();
      var itemChanged = new _rxjs.Subject();
      var itemRemoved = new _rxjs.Subject();
      var pathSubscriptions = [this._firebase.onChildAdded(path, itemAdded), this._firebase.onChildChanged(path, itemChanged), this._firebase.onChildRemoved(path, itemRemoved)];
      var typeUrl = subscription.getTopic().getTarget().getType();
      return new EntitySubscription({
        unsubscribedBy: function unsubscribedBy() {
          FirebaseSubscribingClient._unsubscribe(pathSubscriptions);
        },
        withObservables: {
          itemAdded: _objectToProto["default"].map(itemAdded.asObservable(), typeUrl),
          itemChanged: _objectToProto["default"].map(itemChanged.asObservable(), typeUrl),
          itemRemoved: _objectToProto["default"].map(itemRemoved.asObservable(), typeUrl)
        },
        forInternal: subscription
      });
    }
    /**
     * @private
     */

  }, {
    key: "_eventSubscription",
    value: function _eventSubscription(path, subscription) {
      var itemAdded = new _rxjs.Subject();

      var pathSubscription = this._firebase.onChildAdded(path, itemAdded);

      return new EventSubscription({
        unsubscribedBy: function unsubscribedBy() {
          FirebaseSubscribingClient._unsubscribe([pathSubscription]);
        },
        withObservable: _objectToProto["default"].map(itemAdded.asObservable(), EVENT_TYPE_URL),
        forInternal: subscription
      });
    }
    /**
     * Unsubscribes the provided Firebase subscriptions.
     *
     * @param {Array<Subscription>} subscriptions
     * @private
     */

  }], [{
    key: "_unsubscribe",
    value: function _unsubscribe(subscriptions) {
      subscriptions.forEach(function (subscription) {
        if (!subscription.closed) {
          subscription.unsubscribe();
        }
      });
    }
    /**
     * Creates a `SubscriptionObject` instance to communicate with Spine server.
     *
     * @param {!String} path a path to object which gets updated in Firebase
     * @param {!spine.client.Topic} topic a topic for which the Subscription gets updates
     * @return {SubscriptionObject} a `SubscriptionObject` instance to communicate with Spine server
     */

  }, {
    key: "internalSubscription",
    value: function internalSubscription(path, topic) {
      var subscription = new _subscription_pb.Subscription();
      var id = new _subscription_pb.SubscriptionId();
      id.setValue(path);
      subscription.setId(id);
      subscription.setTopic(topic);
      return subscription;
    }
  }]);

  return FirebaseSubscribingClient;
}(_subscribingClient.SubscribingClient);
/**
 * An implementation of the `AbstractClientFactory` that creates instances of client which exchanges
 * data with the server via Firebase Realtime Database.
 */


var FirebaseClientFactory = /*#__PURE__*/function (_AbstractClientFactor) {
  _inherits(FirebaseClientFactory, _AbstractClientFactor);

  var _super6 = _createSuper(FirebaseClientFactory);

  function FirebaseClientFactory() {
    _classCallCheck(this, FirebaseClientFactory);

    return _super6.apply(this, arguments);
  }

  _createClass(FirebaseClientFactory, null, [{
    key: "_clientFor",
    value:
    /**
     * Creates a new `FirebaseClient` instance which will send the requests on behalf of the provided
     * actor to the provided endpoint, retrieving the data from the provided Firebase storage.
     *
     * Expects that given options contain backend endpoint URL, firebase Database instance and
     * the actor provider.
     *
     * @param {ClientOptions} options
     * @return {Client} a new backend client instance which will send the requests on behalf
     *                  of the provided actor to the provided endpoint, retrieving the data
     *                  from the provided Firebase storage
     * @override
     */
    function _clientFor(options) {
      var httpClient = new _httpClient.HttpClient(options.endpointUrl);
      var endpoint = new _httpEndpoint.HttpEndpoint(httpClient, options.routing);
      var firebaseDatabaseClient = new _firebaseDatabaseClient.FirebaseDatabaseClient(options.firebaseDatabase);

      var requestFactory = _actorRequestFactory.ActorRequestFactory.create(options);

      var subscriptionService = new _firebaseSubscriptionService.FirebaseSubscriptionService(endpoint, options.subscriptionKeepUpInterval);
      var querying = new FirebaseQueryingClient(endpoint, firebaseDatabaseClient, requestFactory);
      var subscribing = new FirebaseSubscribingClient(endpoint, firebaseDatabaseClient, requestFactory, subscriptionService);
      var commanding = new _commandingClient.CommandingClient(endpoint, requestFactory);
      return new _compositeClient.CompositeClient(querying, subscribing, commanding);
    }
  }, {
    key: "createQuerying",
    value: function createQuerying(options) {
      var httpClient = new _httpClient.HttpClient(options.endpointUrl);
      var endpoint = new _httpEndpoint.HttpEndpoint(httpClient, options.routing);
      var firebaseDatabaseClient = new _firebaseDatabaseClient.FirebaseDatabaseClient(options.firebaseDatabase);

      var requestFactory = _actorRequestFactory.ActorRequestFactory.create(options);

      return new FirebaseQueryingClient(endpoint, firebaseDatabaseClient, requestFactory);
    }
  }, {
    key: "createSubscribing",
    value: function createSubscribing(options) {
      var httpClient = new _httpClient.HttpClient(options.endpointUrl);
      var endpoint = new _httpEndpoint.HttpEndpoint(httpClient, options.routing);
      var firebaseDatabaseClient = new _firebaseDatabaseClient.FirebaseDatabaseClient(options.firebaseDatabase);

      var requestFactory = _actorRequestFactory.ActorRequestFactory.create(options);

      var subscriptionService = new _firebaseSubscriptionService.FirebaseSubscriptionService(endpoint, options.subscriptionKeepUpInterval);
      return new FirebaseSubscribingClient(endpoint, firebaseDatabaseClient, requestFactory, subscriptionService);
    }
    /**
     * @override
     */

  }, {
    key: "_ensureOptionsSufficient",
    value: function _ensureOptionsSufficient(options) {
      _get(_getPrototypeOf(FirebaseClientFactory), "_ensureOptionsSufficient", this).call(this, options);

      var messageForMissing = function messageForMissing(option) {
        return "Unable to initialize Client with Firebase storage. The ClientOptions.".concat(option, " not specified.");
      };

      if (!options.endpointUrl) {
        throw new Error(messageForMissing('endpointUrl'));
      }

      if (!options.firebaseDatabase) {
        throw new Error(messageForMissing('firebaseDatabase'));
      }

      if (!options.actorProvider) {
        throw new Error(messageForMissing('actorProvider'));
      }
    }
  }]);

  return FirebaseClientFactory;
}(_clientFactory.AbstractClientFactory);

exports.FirebaseClientFactory = FirebaseClientFactory;
//# sourceMappingURL=firebase-client.js.map